import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { ZigStub } from '@zignaly-open/ui';
import { useIsCloudflareBlocked } from '../../apis/appMeta/use';
import CloudflareBlocked from '../../views/Error/CloudflareBlocked';

const CriticalError: React.FC = () => {
  const { t } = useTranslation(['common', 'error']);
  const [online, setOnline] = useState(navigator.onLine);
  const [isRefreshingAfterOffline, setIsRefreshingAfterOffline] =
    useState(false);

  const isCloudflareError = useIsCloudflareBlocked();

  useEffect(() => {
    const handleBecomeOnline = () => {
      setOnline(true);
      setIsRefreshingAfterOffline(true);
      window.location.reload();
    };
    const handleBecomeOffline = () => {
      setOnline(false);
    };

    window.addEventListener('online', handleBecomeOnline);
    window.addEventListener('offline', handleBecomeOffline);

    return () => {
      window.removeEventListener('online', handleBecomeOnline);
      window.removeEventListener('offline', handleBecomeOffline);
    };
  }, []);

  if (isCloudflareError) {
    return <CloudflareBlocked />;
  }
  return online && !isRefreshingAfterOffline ? (
    <ZigStub
      title={t('critical-error.title')}
      description={t('critical-error.description')}
    />
  ) : (
    <ZigStub
      title={t('error:offline.title')}
      description={t('error:offline.description')}
    />
  );
};

export default CriticalError;
